// couponApi.ts
import axios from 'axios'
import { ICouponModel } from './CouponModel'

// Base URL (sona / garanti)
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

// Endpoints
export const COUPON_CREATE_URL = `${API_URL}api/v1/definition/coupon-management/create`;
export const COUPON_GET_ALL_URL = `${API_URL}api/v1/definition/coupon-management/all`;
export const COUPON_DELETE_URL = `${API_URL}api/v1/definition/coupon-management/delete/`;
export const COUPON_UPDATE_URL = `${API_URL}api/v1/definition/coupon-management/update/`;

// Auth header helper
const getAuthHeaders = () => {
    const token = localStorage.getItem('token')
    return token ? { Authorization: `Bearer ${token}` } : {}
}

// ✅ Create Coupon (id gönderilmez)
export function createCoupon(couponData: ICouponModel) {
    const { id, ...payload } = couponData
    return axios.post(COUPON_CREATE_URL, payload, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    })
}

// ✅ Update Coupon (/update/{id})
export function updateCoupon(couponData: ICouponModel) {
    if (!couponData.id) throw new Error('Güncelleme için id gerekli')
    return axios.post(`${COUPON_UPDATE_URL}${couponData.id}`, couponData, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    })
}

// ✅ Load all locations (pageable destekli)
export function loadCoupons(page = 0) {
    return axios
        .get(COUPON_GET_ALL_URL, {
            headers: getAuthHeaders(),
            params: { page, size: 20 },
            withCredentials: true,
        })
        .then((res) => ({
            ...res,
            data: res.data.payload?.content || res.data.payload || res.data,
        }));
}

// ✅ Delete Location (/delete/{id})
export function deleteCoupon(couponId: string) {
    return axios.post(COUPON_DELETE_URL + couponId);
}

